import { createSlice } from '@reduxjs/toolkit';

import { authActions } from '../auth/index.js';

export interface TeamsState {
    depthChartModified: boolean;
}

const teamsDefaultState: TeamsState = {
    depthChartModified: false,
};

const { reducer: teamsReducer, actions: teamsActions } = createSlice({
    name: 'teams',
    initialState: teamsDefaultState,
    reducers: {
        DepthChartModified: (state, action) => {
            state.depthChartModified = action.payload;
        },
    },
    extraReducers: (builder) => builder.addCase(authActions.PurgeProfile, () => teamsDefaultState),
});

export { teamsReducer, teamsActions, teamsDefaultState };
